<template>
  <section id="venues" class="levels" :class="{ closed: !isOpen }">

    <div class="content">
      <div class="title-header">
        <h1>Venues</h1>
      </div>

<!--      <div class="venue-header top">-->
<!--        <span class="title"></span>-->
<!--        <span class="capacity">Capacity</span>-->
<!--        <span class="rate">Rate</span>-->
<!--      </div>-->

      <div class="spinner centered" id="spinner" v-if="isLoading"></div>


      <ul class="master-items show-photos" v-if="levels">

        <li v-for="(level, key) of levels" class="level-item" :class="{'active': levelId === level.id}" :key="key">
          <a v-on:click="selectLevel(level.id)" id="list-link" class="item-link">
            <div class="item-link__wrapper">
              <h3 class="level-title">{{ level.name }}</h3>
              <svg class="item-chevron" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.001 7.192C12.208 7.192 12.414 7.255 12.589 7.383L23.589 15.383L22.412 17L12.001 9.428L1.58899 17L0.411989 15.383L11.412 7.383C11.588 7.255 11.794 7.192 12.001 7.192Z"
                    fill="black"/>
              </svg>
            </div>

            <!--<div class="spinner" id="spinner" v-if="isLoading && levelId == level.id"></div>-->
          </a>
          <ul class="item-list" v-if="selectedLevel.data.length > 0 && selectedLevel.id == level.id">
            <transition-group
                name="projects-list__item"
                mode="out-in"
                class="projects-list__container"
                stagger="250"
            >
              <li v-for="(venue, venuekey) of selectedLevel.data" :key="venuekey" class="item-list__item">
                <a v-on:click="selectVenue(venue.id)" class="venue-header">
                  <span class="title" v-html="venue.title.rendered"></span>
                  <span class="capacity">{{ venue.acf.capacity }}</span>
                  <span class="rate">{{ venue.acf.rate }}</span>

                </a>
              </li>
            </transition-group>
          </ul>
          <ul class="item-list"></ul>
        </li>
      </ul>
    </div>
    <div class="terms">
      <div class="content">
        <a href="/swp/wp-content/uploads/2023/10/Petco-Park-Venues-and-Rates.pdf" target="_blank">
          <PdfIcon/><span>Download Venue List</span>
        </a>
        <div class="clearfix"></div>
        <a href="/swp/wp-content/uploads/2016/05/Event-Contract-Form-Petco-Park-TC-used-since-01.01.26.pdf" target="_blank">
          <PdfIcon/><span>Petco Park Event Contract Terms & Conditions</span>
        </a>
        <div class="clearfix"></div>
        <a href="/swp/wp-content/uploads/2023/12/Event-Contract-Form-Shell-TC-used-since-01.01.26.pdf" target="_blank">
          <PdfIcon/><span>The Rady Shell Event Contract Terms & Conditions</span>
        </a>
        <div class="clearfix"></div>
        <a href="/swp/wp-content/uploads/2023/12/Event-Contract-Form-Eve-TC-Used-since-01.01.26.pdf" target="_blank">
          <PdfIcon/><span>Eve Event Contract Terms & Conditions</span>
        </a>
        <div class="clearfix"></div>
        <a href="/swp/wp-content/uploads/2026/01/Event-Contract-Form-Diamond-Room-TC-used-since-01.22.26.pdf" target="_blank">
          <PdfIcon/><span>Diamond Room Event Contract Terms & Conditions</span>
        </a>
        <div class="clearfix"></div>
        <p>Please note prices are subject to change. <br> A $20,000 minimum is required on all ballpark events.
          <br> Rates are based on a 4 Hour time rental.</p>
      </div>
    </div>
  </section>
</template>

<script>
import accordion from '@/components/Accordion.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import PdfIcon from './PdfIcon.vue';


export default {
  name: "levels",
  props: [],
  data() {
    return {
      initialLoad: true,
      debug: false
    }
  },
  components: { accordion, PdfIcon },
  computed: {
    ...mapState({
      wpUrl: 'baseUrl',
    }),
    ...mapState([
      'wpUrl',
      'levels',
      'selectedLevel',
      'isLoading',
      'venues',
    ]),
    levelId() {
      return this.$store.state.selectedLevel.id;
    },
    isOpen() {
      return this.$store.state.isMainPanelOpen;
    },
  },
  methods: {
    ...mapMutations([
      'setLevel',
      'setVenue',
      'toggleMainPanel',
      'setLoading',
      'setImages',
    ]),
    ...mapActions([]),
    selectVenue: function (venueId) {
      this.toggleMainPanel(false);
      // this.initialLoad = false;
      const id = parseInt(venueId);
      const venue = this.venues.find((v) => {
        return v.id === id;
      });
      this.setVenue(venue);
      // console.log(venue);

      if (venue.acf) {
        this.setImages(this.formatImages(venue.acf.images));
      }
      this.$router.push({ name: 'venue', params: { venueId: venue.id } });

    },
    loadLevel(levelId) {
      this.isLoading = true;
      // context.commit('setLoading', true);
      this.axios.get(`${this.wpUrl}venue-detail?venue-levels=${levelId}`)
          .then(response => {
            // this.isLoading = false;
            const level = {};
            level.id = levelId;
            level.data = response.data;
            this.setLevel(level);
            this.setLoading(false);
          })
    },
    selectLevel(levelId) {
      const venues = this.venues.filter((v) => {
        return v['venue-levels'][0] === levelId;
      });
      const level = {};
      level.id = levelId;
      level.data = venues;
      this.setLevel(level);
    },
    formatImages(imgArr) {
      let tempArr = [];
      for (let i = 0; i < imgArr.length; i++) {
        tempArr.push(imgArr[i].sizes.large);
      }
      return tempArr;
    },

  },
  mounted() {
    // eslint-disable-next-line
    // console.log('hi: ');
    this.isClosed = false;
    // eventHub.$on('close-venues', () => {
    //   this.isClosed = true;
    // });
    // eventHub.$on('open-venues', () => {
    //   this.isClosed = false;
    // });
  },
}
</script>

<style scoped lang="scss">
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .5s ease;
}

.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}

.list-enter-active, .list-leave-active {
  transition: all 1s;
}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(30px);
}

a {
  cursor: pointer;
}



.spinner.centered {
  position: absolute;
  left: 48%;
  top: 250px;
}

.panel.master:before {
  left: 0;
}

.projects-list__item {
  backface-visibility: hidden;
  transform-origin: 10% 50%;
  z-index: 1;

  /* moving */
  &-move {
    transition: all 600ms ease-in-out 50ms
  }

  /* appearing */
  &-enter-active {
    transition: all 300ms ease-out
  }

  /* disappearing */
  &-leave-active {
    transition: all 200ms ease-in;
    position: absolute;
    z-index: 0;
  }

  /* appear at / disappear to */
  &-enter,
  &-leave-to {
    opacity: 0;
    /*transform: translateY(10px);*/
  }

  &-enter {
    transform: scale(0.9) translateY(50px);
  }
}

.slide-fade-move {
  transition: transform 1s;
}
</style>
